import async from 'components/Async';
import PageRouteUtil from 'routes/util';
import { access } from '../../constants';

const Email2ClickDocsPage = async(() => import('./integrationDocs/Email2ClickDocsPage'));
const WebApiDocsPage = async(() => import('./integrationDocs/WebApiDocsPage'));
const EmailDirectClickDocsPage = async(() => import('./integrationDocs/EmailDirectClickDocsPage'));
const XmlDocsPage = async(() => import('./integrationDocs/XmlDocsPage'));
const Email2ClickIntegrationPage = async(() => import('./integrationDocs/email2ClickIntegrationPage'));
const WebApiIntegrationPage = async(() => import('./integrationDocs/webApiIntegrationPage'));
const EmailDirectClickIntegrationPage = async(() => import('./integrationDocs/emailDirectClickIntegrationPage'));
const XmlIntegrationPage = async(() => import('./integrationDocs/xmlIntegrationPage'));
const SyndicatedJobFeedReportPage = async(() => import('./SyndicatedJobFeedReportPage'));
const ContractSettingsPage = async(() => import('./ContractSettingsPage'));
const XmlFeedSetupPage = async(() => import('./XmlFeedSetupPage'));
const CreateEditXmlFeedPage = async(() => import('./syndicatedXml/forms/CreateEditXmlCampaign'));
const AssignSourcesPage = async(() => import('./AssignSourcesPage'));
const ConversionReportPage = async(() => import('./ConversionReport'));

const syndicatedJobsRouteList = [
   {
      path: '/syn-job-feed/report',
      component: SyndicatedJobFeedReportPage,
   },
   {
      path: '/syn-job-feed/conversion-reporting',
      component: ConversionReportPage,
   },
   {
      path: '/syn-job-feed/integration-docs/api-docs',
      component: WebApiDocsPage,
   },
   {
      path: '/syn-job-feed/integration-docs/email-docs',
      component: Email2ClickDocsPage,
   },
   {
      path: '/syn-job-feed/integration-docs/direct-docs',
      component: EmailDirectClickDocsPage,
   },
   {
      path: '/syn-job-feed/integration-docs/xml-docs',
      component: XmlDocsPage,
   },
   {
      // unlisted previous versions of the integration docs (no nav entries)
      path: '/syn-job-feed/integration-docs/api-docs-legacy',
      component: WebApiIntegrationPage,
   },
   {
      path: '/syn-job-feed/integration-docs/email-docs-legacy',
      component: Email2ClickIntegrationPage,
   },
   {
      path: '/syn-job-feed/integration-docs/direct-docs-legacy',
      component: EmailDirectClickIntegrationPage,
   },
   {
      path: '/syn-job-feed/integration-docs/xml-docs-legacy',
      component: XmlIntegrationPage,
   },
   {
      path: '/syn-job-feed/settings',
      component: ContractSettingsPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/syn-job-feed/xml-feed-setup',
      requiresDeSession: true,
      component: XmlFeedSetupPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/syn-job-feed/xml-feed-setup/:subroute',
      requiresDeSession: true,
      component: CreateEditXmlFeedPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      // KEEP twin (AOE-free pickers) — de-shutdown-decisions §2 KEEP+FIX
      path: '/syn-job-feed/xml-feed-setup-keep',
      component: XmlFeedSetupPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/syn-job-feed/xml-feed-setup-keep/:subroute',
      component: CreateEditXmlFeedPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
   {
      path: '/syn-job-feed/assign-sources',
      component: AssignSourcesPage,
      access: access.getAdminAccessByApp.synJobFeed,
   },
];

export default PageRouteUtil.getPageRouteListHavingDefaultProperties(syndicatedJobsRouteList);
